import type { EdgelessToolbarI18nKey } from '@blocksuite/affine-shared/services';

import {
  EdgelessBrushDarkIcon,
  EdgelessBrushLightIcon,
  EdgelessHighlighterDarkIcon,
  EdgelessHighlighterLightIcon,
} from './icons';
import type { Pen } from './types';

export const penIconMap = {
  dark: {
    brush: EdgelessBrushDarkIcon,
    highlighter: EdgelessHighlighterDarkIcon,
  },
  light: {
    brush: EdgelessBrushLightIcon,
    highlighter: EdgelessHighlighterLightIcon,
  },
};

export const penInfoMap: {
  [k in Pen]: { tipKey: EdgelessToolbarI18nKey; shortcut: string };
} = {
  brush: {
    tipKey: 'toolbar.pen',
    shortcut: 'P',
  },
  highlighter: {
    tipKey: 'toolbar.highlighter',
    shortcut: '⇧ P',
  },
};
